export const capitalize = (value: any, regex?: RegExp) => {
  if (typeof value !== 'string') return value;
  const words = value.trimLeft().toLowerCase().split(' ');

  if (regex) {
    const matches = value.match(new RegExp(regex, 'g'));

    const formatMatches = matches?.[0]
      .split(' ')
      .reduce((acc, cur, i) => {
        return (acc += `${cur.charAt(0).toUpperCase() + cur.slice(1)} `);
      }, '')
      .trim();

    const splittedText = value.split(new RegExp(regex));
    return `${splittedText[0] + formatMatches + splittedText[1]}`;
  }

  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
